module.exports = __webpack_public_path__ + "img/Group 14 (1).3f03e1b7.svg";